/**
 * Iframe Security Utility Functions
 *
 * Shared utility functions for iframe security checks
 */

/**
 * Check if a hostname is localhost
 */
export function isLocalhostHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

/**
 * Check if the current window location is localhost
 */
export function isCurrentLocationLocalhost(): boolean {
  return isLocalhostHostname(window.location.hostname);
}

/**
 * Check if the current context is secure (HTTPS or localhost)
 */
export function isSecureContext(): boolean {
  return (
    window.location.protocol === 'https:' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
}

/**
 * Check if the app is running in an iframe
 */
export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    // If we can't access window.top, we're likely in an iframe
    return true;
  }
}

/**
 * Check if we're in development environment
 */
export function isDevelopmentEnv(): boolean {
  return process.env.NODE_ENV === 'development';
}

